import Consts from '../../consts/clientConsts'
import Position from './Position'

export default class {

    Id = null;

    Name = null;
    
    Type = null;

    Address = null;

    Marker = null;

    Position = null;

    Radius = null;

    Opened = false;

    IsPriceMonitoring = false;

    mapFromDto(viewModel, startPosition = null) {
        if(!viewModel)
            return this;

        let dto = viewModel;

        this.Id = dto.Id;
        this.Address = dto.Address;
        this.Name = dto.Name;
        this.Type = Consts.TradePointType.find(e => e.Id == dto.Type);
        this.IsPriceMonitoring = dto.IsPriceMonitoring;
        this.Marker = `/img/map_mini_marker${this.Type.Id}${this.IsPriceMonitoring ? "_pm" : ""}.png`;
        this.Position = new Position().mapFromDto(dto.Position);

        if(startPosition)
            this.radiusCalculate(startPosition);

        return this;
    }

    radiusCalculate(centerPosition) {
        this.Radius = (Math.pow((this.Position.lat - centerPosition.lat), 2) + Math.pow((this.Position.lng - centerPosition.lng), 2));
    }

    openOrCloseInfoWindow() {
        this.Opened = !this.Opened;
    }
}